<template>
  <div class="drag-wrapper flex-shrink-0">
    <v-file-input
      v-model="files"
      type="file"
      ref="file"
      class="d-none"
      accept=".png, .jpeg, .jpg, .mp4"
      @change="onFileChanged"
    />
    <div
      ref="selectFrame"
      :class="['box text-body-3 d-flex flex-column justify-center',textColor]"
      :style="customStyling"
      @drop="onFileChanged($event)"
    >
      <div v-show="!isLoading">
        <slot name="text" />
        <div>
          <v-btn
            class="text-body-2 primary-001--text mt-1"
            small
            depressed
            color="white"
            @click="onUpload"
          >
            {{ $t('WHATSAPP_TEMPLATE.UPLOAD_FILE') }}
          </v-btn>
        </div>
      </div>
      <div v-show="isLoading">
        {{ $t('DEFAULT_REPLY.UPLOADING') }}
      </div>
    </div>
    <Notification
      ref="notification"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getThumbnailForVideo, base64ToBlob } from '@/utils';
import uploadApi from '../../../restapis/upload';

export default {
  name: 'DragPhoto',
  props: {
    // 是否有編輯圖片按鈕
    allowChangeImage: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: 'neutral-043--text'
    },
    // 需傳入 Hex Color Code
    initBorderColor: {
      type: String,
      default: '#BBBFD3' // $neutral-cold-054
    },
    imgUrl: {
      type: String,
      default: ''
    },
    imgSize: {
      type: Array,
      default: () => []
      // EX: [1024,1024]，單位為 px
    },
    imageSize: {
      type: Number,
      default: 5
      // 單位為 MB
    },
    videoSize: {
      type: Number,
      default: 16
      // 單位為 MB
    }
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    customStyling() {
      return [
        {
          borderColor: `${this.borderColor}`,
          borderWidth: `${this.borderWidth}`
        }
      ];
    }
  },
  data() {
    return {
      borderColor: this.borderColor,
      borderWidth: '1px',
      isEdit: false,
      isSelectedFile: false,
      files: { name: this.imgUrl } || {},
      isLoading: false,
      imageUrl: ''
    };
  },
  mounted() {
    this.$refs.selectFrame.ondragleave = (e) => {
      e.preventDefault();
      this.borderColor = this.initBorderColor;
      this.borderWidth = '1px';
    };
    this.$refs.selectFrame.ondrop = (e) => {
      e.preventDefault();
      this.borderColor = this.initBorderColor;
      this.borderWidth = '1px';
    };
    this.$refs.selectFrame.ondragenter = (e) => {
      e.preventDefault();
      this.borderColor = '#608FFF';
      this.borderWidth = '2px';
    };
    this.$refs.selectFrame.ondragover = (e) => {
      e.preventDefault();
      this.borderColor = '#608FFF';
      this.borderWidth = '2px';
    };
  },

  methods: {
    onUpload() {
      this.$refs.file.$refs.input.click();
    },
    async onFileChanged(event) {
      console.log('onFileChanged');
      let mediaType = 'image';
      try {
        this.isSelectedFile = false;
        let file = null;
        if (event.dataTransfer) {
          file = event.dataTransfer.files[0];
        } else {
          file = event;
        }
        console.log(file);
        // Check file type
        if (!['png', 'jpg', 'jpeg', 'mp4'].includes(file.type.slice(6))) {
          const notificationObj = {
            title: this.$t('DEFAULT_REPLY.MEDIA_TYPE_MUST_BE'),
            status: 'error'
          };
          this.$refs.notification.openNotification(notificationObj);
          return;
        }

        if (['png', 'jpg', 'jpeg'].includes(file.type.slice(6))) {
          mediaType = 'image';
        } else {
          mediaType = 'video';
        }

        const upperLimitFileSize = mediaType === 'image' ? this.imageSize : this.videoSize;
        if (this.checkFileSize(file.size, mediaType)) {
          const notificationObj = {
            title: `${this.$t('STICKER_PACK.FILE_SIZE_MUST_BE_LESS_THAN')} ${upperLimitFileSize} MB`
          };
          this.$refs.notification.openNotification(notificationObj);
          return;
        }

        this.isLoading = true;
        const blob = new Blob([file], { type: file.type });

        let uploadData = null;
        let previewUrl = '';
        if (mediaType === 'image') {
          uploadData = await uploadApi.postPhoto({
            photo: blob,
            team: this.currentUserDict.team
          });
        } else {
          const fileUrl = URL.createObjectURL(file);
          const thumbUrl = await getThumbnailForVideo(fileUrl);

          const thumbBlob = base64ToBlob(thumbUrl);
          const uploadThumbnailData = await uploadApi.postPhoto({
            photo: thumbBlob,
            team: this.currentUserDict.team
          });
          previewUrl = uploadThumbnailData.data.path;
          uploadData = await uploadApi.postMedia({
            media: blob,
            team: this.currentUserDict.team,
            platform: 'line',
            type: 11
          });
        }

        this.isSelectedFile = true;
        this.files = { name: uploadData.data.path };
        this.$emit('new-upload-img', this.files.name);
        this.$emit('new-upload-media', { mediaType: mediaType, url: uploadData.data.path, previewUrl: previewUrl });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        const notificationObj = {
          title: this.$t('FAILED_TO_UPLOAD_FILE')
        };
        this.$refs.notification.openNotification(notificationObj);
      }
    },
    checkFileSize(fileSize, upperLimitFileSize) {
      return fileSize > (1024 * 1024) * upperLimitFileSize;
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-wrapper{
  width: 100%;
  height: 100%;
}
::v-deep.v-image {
  .v-image__image.v-image__image--contain {
    border-radius: 4px !important;
  }
}
.box {
  width: 100%;
  height: 100%;
  min-height: 159px;
  cursor: default;
  border: 1px $neutral-cold-054 dashed;
  // background-color: var(--color);
  // padding: 24px 18px 24px 18px;
  text-align: center;
  border-radius: 4px;
}

.v-card {
  position: relative;
  width: 100%;
  height: 100%;
  &::after {
    opacity: 1;
    transition: opacity .3s ease-in-out;
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
    border-radius: 4px;
  }
}

.v-card:not(.on-hover) {
   &::after {
    opacity: 0;
   }

}

.action-btn {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  top: 0;
  div:hover {
    cursor: pointer;
  }
}

</style>
